;
define("product_list_edit_item.tpl", function(){});

